import { render } from "./HomeSubtitle.vue?vue&type=template&id=5b65faa6&scoped=true&ts=true"
import script from "./HomeSubtitle.vue?vue&type=script&lang=ts"
export * from "./HomeSubtitle.vue?vue&type=script&lang=ts"

import "./HomeSubtitle.vue?vue&type=style&index=0&id=5b65faa6&scoped=true&lang=css"

import exportComponent from "/Users/uchidakouhei/workspace/docker/new-mentalnc-docker/src/new-well-labo.members.mentalnc.com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b65faa6"]])

export default __exports__